import styled from 'styled-components';
import { HashLink as RouterLink } from 'react-router-hash-link';

import { Media } from 'assets/Mixins.style';

export const Item = styled(RouterLink)`
  display: block;
  width: 100%;
  padding: 5px;
  margin: 2px;
  color: ${props => (props.color ? props.color : props.theme.color)};
  transition: 0.2s all;
  text-align: center;
  cursor: pointer;
`;

export const ItemExternal = styled.a`
  display: block;
  width: 100%;
  padding: 5px;
  padding: 5px;
  margin: 2px;
  color: ${props => (props.color ? props.color : props.theme.color)};
  transition: 0.2s all;
  text-align: center;
  cursor: pointer;
`;

export const Icon = styled.i`
  display: ${props => props.theme.display || 'block'};
  justify-content: center;
  align-items: center;
  width: ${props => props.theme.width || '100%'};
  height: ${props => props.theme.height || 'auto'};
  margin: ${props => props.theme.margin || 0};
  background-color: ${props => props.theme.backgroundColor || 'transparent'};
  border-radius: ${props => props.theme.borderRadius || '0'};
  color: ${props => props.theme.color || 'inherit'};
  text-align: center;
  font-size: ${props => `${props.size}`};
  ${Item}:hover & {
    background-color: ${props =>
      props.theme.backgroundColorOnHover || 'transparent'};
  }
  ${ItemExternal}:hover & {
    background-color: ${props =>
      props.theme.backgroundColorOnHover || 'transparent'};
  }
`;

export const Text = styled.span`
  display: inline-block;
  margin: 2px;
  transition: 0.2s all;
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;
